import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ConvexReactClient } from "convex/react";
import { ConvexBetterAuthProvider } from "@convex-dev/better-auth/react";
import type { AuthClient } from "@convex-dev/better-auth/react";
import { resolveConvexEnv } from "./env";
import { createPeekAuthClient } from "./lib/auth-client";
import { ConfigError } from "./components/ConfigError";
import { App } from "./App";
import "./index.css";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("#root element missing from index.html");
}
const root = createRoot(rootEl);

const envResult = resolveConvexEnv(import.meta.env);

if (!envResult.ok) {
  root.render(
    <StrictMode>
      <ConfigError message={envResult.error} />
    </StrictMode>,
  );
} else {
  const convex = new ConvexReactClient(envResult.env.convexUrl, { expectAuth: true });
  const authClient = createPeekAuthClient(envResult.env);

  root.render(
    <StrictMode>
      {/* @convex-dev/better-auth's `AuthClient` union type resolves `useSession().data`
          to `never` for a concretely-plugin-typed client (a type-computation limitation
          in the library, not a real incompatibility) — cast, verified harmless: `authClient`
          is used as-is (uncast) everywhere else, including `App`'s `useSession()` call below. */}
      <ConvexBetterAuthProvider client={convex} authClient={authClient as unknown as AuthClient}>
        <App authClient={authClient} />
      </ConvexBetterAuthProvider>
    </StrictMode>,
  );
}
